import Frame from "components/shared/Frame";
import React from "react";
import Button from "components/shared/Button";
import { Form, Formik, FormikHelpers } from "formik";
import FormField from "components/shared/FormField";
import * as Yup from "yup";
import loader from "assets/loader.gif";
import axios from "axios";
import { IStep } from "types";
import { api } from "../../constants";
import { toast } from "react-toastify";

const RegistrationStep: React.FC<IStep> = ({ onBack, onNext, value }: any) => {
  const init = {
    firstName: value?.firstName || "",
    lastName: value?.lastName || "",
    username: value?.username || "",
    email: value?.email || "",
    password: "",
    confirmPassword: "",

    role: value?.role || "0", // by default student
  };

  const validationSchema = Yup.object().shape({
    firstName: Yup.string()
      .min(2, "Your first name should be atleast 3 characters long")
      .required("Your first name is required"),
    lastName: Yup.string()
      .min(2, "Your last name should be atleast 3 characters long")
      .required("Your last name is required"),
    username: Yup.string()
      .min(3, "Username should be atleast 3 characters long")
      .max(32, "Your username should be maximum 32 characters long")
      .required("Username is required"),

    password: Yup.string()
      .min(6, "Password should minimum 6 characters long")
      .matches(/[0-9a-zA-Z]/, "Password can only contain letters and numbers")
      .required("Password is required"),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("password"), null], "Passwords must match")
      .required("Password confirmation is required"),
    email: Yup.string().email().required().label("Email"),
  });

  const handleFormSubmission = async (
    data: typeof init,
    actions: FormikHelpers<typeof init>
  ) => {
    actions.setSubmitting(true);

    const inputData = { ...data };

    const postData = {
      channel: "indianu",
      cmd: "ModHandle.signUpIndianPortal",
      password: inputData?.password,
      user: {
        username: inputData.username,
        f_name: inputData?.firstName,
        l_name: inputData?.lastName,
        email: inputData?.email,
        phone_number: value?.data?.phone_number || "",
        role: inputData.role,
        password: inputData?.password,
        s_id: value?.s_id || "",
      },
    };

    axios
      .post(api, postData)
      .then((results) => {
        console.log("response", results.data);
        if (results?.data?.error) {
          toast.error(results.data.error);
        } else {
          onNext(results.data.user_info);
        }
      })
      .catch(({ response }) => {
        toast.error(response.data.error);
      })
      .finally(() => {
        actions.setSubmitting(false);
      });
  };

  return (
    <Frame
      title={`Let's create your ${value.name ? value.name : "Teacher"} account`}
      onBackButtonClick={onBack}
    >
      <Formik
        initialValues={init}
        validationSchema={validationSchema}
        onSubmit={handleFormSubmission}
      >
        {({ handleSubmit, isSubmitting, errors }) => (
          <Form
            onKeyDown={(e) => {
              if (e.key == "Enter") {
                handleSubmit();
              }
            }}
          >
            {!isSubmitting && (
              <div>
                <div className="row">
                  <div className="col-6">
                    <FormField name="firstName" placeholder="First Name" />
                  </div>
                  <div className="col-6">
                    <FormField name="lastName" placeholder="Last Name" />
                  </div>
                </div>
                <div className="row">
                  <div className="col-6">
                    <FormField name="username" placeholder="Username" />
                  </div>
                  <div className="col-6">
                    <FormField type="email" name="email" placeholder="Email" />
                  </div>
                </div>

                <div className="row">
                  <div className="col-12">
                    <FormField
                      type="password"
                      name="password"
                      placeholder="Password"
                    />
                  </div>
                  <div className="col-12">
                    <FormField
                      style={{ fontWeight: "400" }}
                      type="password"
                      name="confirmPassword"
                      placeholder="Confirm Password"
                    />
                  </div>
                </div>
                {(errors as any)?.general && (
                  <div className="error">
                    <p>{(errors as any)?.general}</p>
                  </div>
                )}
                <div className="row">
                  <div className="col-12 flex justify-center">
                    <Button value="Submit" onClick={handleSubmit} />
                  </div>
                </div>
              </div>
            )}

            {isSubmitting && (
              <img
                src={loader}
                style={{ width: 300, margin: "auto" }}
                alt="loader"
              />
            )}
          </Form>
        )}
      </Formik>
    </Frame>
  );
};

export default RegistrationStep;
